import {post} from "../API/cloudFunctions";


export default class sensor_type{
  data={
    name: '',//the name of the type
    step: '',//number of steps in minuts
    rra: [],// ["AVERAGE", "MIN", "MAX","LAST"]
    minimum: 'U',
    maximum: 'U',
    dst: ''//["GAUGE","COUNTER","ABSOLUTE","DERIVED",]
  };
  constructor(obj){
    if(obj){
    this.data.name=obj.name;
    this.data.step=parseInt(obj.step);
    this.data.minimum=obj.minimum!='U'?parseFloat(obj.minimum):obj.minimum;
    this.data.maximum=obj.maximum!='U'?parseFloat(obj.minimum):obj.minimum;
    this.data.rra=obj.rra;
    this.data.dst=obj.dst;
    //  console.log(Object.values(this.data));
    }
  }

  addSensorType(defa){
    if(defa&&defa=='default'){
    return new Promise((resolve, reject) => {
      this.data.uid='default';
        let data = {
          data :this.data
        }
      post('addSensorType', data).then(success => {
        console.log("SensorType sent with success")
        console.log(success)
        resolve(success)
      }).catch(error => {
        console.error('failed to send SensorType')
        console.error('error', error)
        reject(error)
      })

    })
    }else{
      return new Promise((resolve, reject) => {
        let data = {
          data :this.data
        }
        post('addSensorType', data).then(success => {
          console.log("SensorType sent with success")
          console.log(success)
          resolve(success)
        }).catch(error => {
          console.error('failed to send SensorType')
          console.error('error', error)
          reject(error)
        })

      })
    }
  }


  static getSensorsType(defa) {
    if(defa&&defa=='default'){
      console.log('default Get SensorTypes !!!!!!!!!!!!!!!!!');
      let body ={
        data :{
          uid:'default'
        }
      }
      return new Promise((resolve, reject) => {
        post('getSensorsType',body).then(success => {
          resolve(success)

        }).catch(error => {
          reject(error)
        })
      })

    }else{
    return new Promise((resolve, reject) => {
      post('getSensorsType').then(success => {
        resolve(success)

      }).catch(error => {
        reject(error)
      })
    })
    }


    // User is signed in.
  }
}



// WEBPACK FOOTER //
// ./src/Class/sensor_type.js